module.exports = __webpack_public_path__ + "img/drag.427b17aa.svg";